import { render, staticRenderFns } from "./OtherplaceEditor.vue?vue&type=template&id=79b8f8a9&"
import script from "./OtherplaceEditor.vue?vue&type=script&lang=js&"
export * from "./OtherplaceEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports